import * as yup from 'yup';

import { PermissiblePurposeDeclineModalFields } from './types';

export const permissiblePurposeDeclineSchema = yup.object({
  [PermissiblePurposeDeclineModalFields.denialReason]: yup
    .string()
    .nullable()
    .required('Field is required'),
});
